import React from "react";
import { Reveal } from "../shared/Reveal";

const REPORTS = [
  {
    key: "esg",
    label: "ESG & SUSTAINABILITY",
    title: "Audit-Ready ESG",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" /><path d="M2 21c0-3 1.85-5.36 5.08-6" /></svg>
    ),
    points: [
      "Automated carbon and energy reporting aligned to recognised ESG frameworks",
      "Scope 1, 2 & 3 visibility built on measured data — not estimates",
      "Board- and investor-ready sustainability evidence, on demand",
    ],
  },
  {
    key: "financial",
    label: "FINANCIAL",
    title: "Numbers Leadership Trusts",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18" /><path d="M7 16l4-5 3 3 5-7" /></svg>
    ),
    points: [
      "Cost, consumption and savings quantified per site, circuit and asset",
      "Verified ROI on every efficiency and capital investment decision",
      "Budget forecasting grounded in real operational behaviour",
    ],
  },
  {
    key: "management",
    label: "MANAGEMENT & OPERATIONS",
    title: "One Source of Truth",
    icon: (
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></svg>
    ),
    points: [
      "Live multi-site performance benchmarking and league tables",
      "Anomaly, fault and downtime reporting before failures escalate",
      "Custom dashboards for leadership, facilities and finance teams",
    ],
  },
];

export default function Reporting() {
  return (
    <section id="reporting" className="reporting">
      <div className="wrap">
        <Reveal className="vembadge" tag="div" data-testid="vem-badge">VEM<span className="tm">&trade;</span> · VIRTUAL ENERGY MANAGEMENT</Reveal>
        <Reveal className="eyebrow" tag="div">REPORTING ON A DIFFERENT LEVEL</Reveal>
        <Reveal className="h2" tag="div">Not Just Savings. <span className="g">Intelligence for the Whole Boardroom.</span></Reveal>
        <Reveal className="lead" tag="p">Saving money is one output. Through <b style={{ color: "#fff" }}>Virtual Energy Management (VEM&trade;)</b>, your data becomes audit-ready reporting that speaks the language of every stakeholder in the business — from the sustainability committee to the CFO.</Reveal>

        <div className="rephighlight">
          <Reveal className="rhcard" tag="div" data-testid="report-realtime">
            <span className="livedot"><span className="livepulse" /></span>
            <div>
              <div className="rhtitle">Minute-by-Minute, in Real Time</div>
              <p>Live reporting across every site and circuit — not monthly estimates or one-off snapshots.</p>
            </div>
          </Reveal>
          <Reveal className="rhcard" tag="div" data-testid="report-predictive">
            <span className="rhicon">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></svg>
            </span>
            <div>
              <div className="rhtitle">Predictive Alerts on Every Asset</div>
              <p>Anomalies and developing faults flagged before they become failures — across all assets, automatically.</p>
            </div>
          </Reveal>
        </div>

        <div className="repgrid">
          {REPORTS.map((r, i) => (
            <Reveal className="repcard" tag="div" key={r.key} style={{ transitionDelay: `${i * 0.09}s` }} data-testid={`report-${r.key}`}>
              <div className="repicon">{r.icon}</div>
              <div className="replabel">{r.label}</div>
              <h3>{r.title}</h3>
              <ul>
                {r.points.map((p) => (
                  <li key={p}><span className="tick" />{p}</li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>

        <Reveal className="repline" tag="div" data-testid="reporting-closing">
          One platform. Every report. <span className="g">Measured, verified and ready for the boardroom.</span>
        </Reveal>
      </div>
    </section>
  );
}
